import { Media } from '../presentational/media';
import Skeleton from '../presentational/skeleton';

export default function SkeletonMythicPlusRuns() {
	return (
		<div className="slds-m-bottom--x-large rio-m-bottom-mobi--large">
			<Media greaterThanOrEqual="md">
				<div style={{ display: 'flex' }}>
					<Skeleton width={91} height={32} style={{ marginRight: 12, borderRadius: '0.25rem 0.25rem 0 0' }} />
					<Skeleton
						width={114}
						height={32}
						style={{ marginRight: 12, borderRadius: '0.25rem 0.25rem 0 0' }}
					/>
					<Skeleton
						width={118}
						height={32}
						style={{ marginRight: 12, borderRadius: '0.25rem 0.25rem 0 0' }}
					/>
					<Skeleton
						width={160}
						height={32}
						style={{ marginRight: 12, borderRadius: '0.25rem 0.25rem 0 0' }}
					/>
				</div>
			</Media>
			<Media lessThan="md">
				<div style={{ display: 'flex' }}>
					<Skeleton width={120} height={42} style={{ marginRight: 12, borderRadius: '0.25rem 0.25rem 0 0' }} />
				</div>
			</Media>

			<Skeleton height={38} />
			<Skeleton variant="item" height={340} animate />
		</div>
	)
}
